import TreeApi from '@/api/common/tree';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';

const tree = {
  state: {
    dynamicTreeFlag: null,
    disablePhysicalTreeFlag: null,
    treeSearchKeywordLimitLength: 0,
    treeSearchUnableKeywords: null,
    // 논리 그룹 트리
    logicalTreeData: [],
    logicalTreeLoading: false,
    // 물리 그룹 트리
    physicalTreeData: [],
    physicalTreeLoading: false,
  },
  mutations: {
    /**
     * 논리 그룹 트리 데이터를 설정한다.
     * @author Ju
     * @param  {[type]} state [description]
     * @param  {[type]} value [description]
     */
    setLogicalTreeData: (state, value) => {
      state.logicalTreeData = value;
    },
    /**
     * 물리 그룹 트리 데이터를 설정한다.
     * @author Ju
     * @param  {[type]} state [description]
     * @param  {[type]} value [description]
     */
    setPhysicalTreeData: (state, value) => {
      state.physicalTreeData = value;
    },
    setLogicalTreeLoading: (state, value) => {
      state.logicalTreeLoading = value;
    },
    setPhysicalTreeLoading: (state, value) => {
      state.phyiscalTreeLoading = value;
    },
    /**
     * 동적 트리 사용 여부를 설정한다.
     * @author Ju
     * @param  {[type]} state [description]
     * @param  {[type]} value [description]
     */
    setDynamicTreeFlag: (state, value) => {
      state.dynamicTreeFlag = value;
    },
    setTreeSearchKeywordLimitLength: (state, value) => {
      state.treeSearchKeywordLimitLength = value;
    },
    setDisablePhysicalTreeFlag: (state, value) => {
      state.disablePhysicalTreeFlag = value;
    },
    setTreeSearchUnableKeywords: (state, value) => {
      const keywords = [];
      if (!isEmpty(value)) {
        forEach(value, (data) => {
          keywords.push(data.basicinfoSubname);
        });
      }
      state.treeSearchUnableKeywords = keywords;
    },
  },
  actions: {
    /**
     * 논리 그룹 트리 데이터를 로드한다.
     * @author Ju
     * @param  {[type]} commit [description]
     * @return {Object} Promise 객체
     */
    loadLogicalTreeData({ commit }) {
      return new Promise((resolve, reject) => {
        commit('setLogicalTreeLoading', true);
        TreeApi.getLogicalTreeData({})
          .then((response) => {
            if (response.data.success) {
              commit('setLogicalTreeData', [response.data.children]);
              resolve(true);
            } else {
              reject(Error('error'));
            }
          })
          .catch((e) => {
            reject(Error(e.message));
          })
          .finally(() => {
            commit('setLogicalTreeLoading', false);
          });
      });
    },
    /**
     * 물리 그룹 트리 데이터를 로드한다.
     * @author Ju
     * @param  {[type]} commit [description]
     * @return {Object} Promise 객체
     */
    loadPhysicalTreeData({ commit }) {
      return new Promise((resolve, reject) => {
        commit('setPhysicalTreeLoading', true);
        TreeApi.getPhysicalTreeData({})
          .then((response) => {
            if (response.data.success) {
              commit('setPhysicalTreeData', [response.data.children]);
              resolve(true);
            } else {
              reject(Error('error'));
            }
          })
          .catch((e) => {
            reject(Error(e.message));
          })
          .finally(() => {
            commit('setPhysicalTreeLoading', false);
          });
      });
    },
  },
};

export default tree;



// WEBPACK FOOTER //
// ./src/store/modules/tree.js